module.exports = __webpack_public_path__ + "static/media/vesap5-logo.d3aac3f4.png";